module.exports = __webpack_public_path__ + "static/media/ChauffeurNY.9e661747.wav";